module.exports = __webpack_public_path__ + "static/media/avatar_doctor.4e805d5e.jpg";